import { ARTICLE_DATE_TYPE, NavigationItem } from '../../types/model'
import type { Article, NavigationItemWithArticles } from '../../types/domain'
import theme from '../../theme'
import { Modal, ArticlesList } from '../components'
import texts from '../texts'
import { openArticle } from './common'

interface CoverageProps {
  title: string
  open: boolean
  onClose: () => void
  isLoading: boolean
  error: boolean
  data?: Article[] | null
}

const Coverage = ({
  title,
  open,
  onClose,
  isLoading,
  error,
  data,
}: CoverageProps) => {
  const handleOpenArticle = (article: Article) => {
    const evParams = {
      name: NavigationItem.Coverage as NavigationItemWithArticles,
      destinationArticleId: article.articleId,
      destinationMediaId: article.mediaProviderId,
    }
    openArticle(article.url, evParams)
  }
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      sx={{
        '--modal-bckg-color': theme.palette.neutral.lightest,
      }}
    >
      <ArticlesList
        isFetching={isLoading}
        // PAYPER-1123: de cara al usuario, coverage no distingue "sin
        // resultados" de "error al cargar" (mismo copy), así que se trata
        // el error como una lista vacía en vez de pasar `error` a la lista.
        articles={error ? [] : (data as Article[])}
        noResultsLabel={texts.getCoverageEmptyLabel()}
        onClickArticle={handleOpenArticle}
        name='coverage'
        sx={{ mt: 1 }}
        isCompact
      />
    </Modal>
  )
}

export default Coverage
